<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <div>
            <el-row>

              <el-col :span="10" class="item">
                <el-form-item label="选择问卷调查" prop="askAnswerNameCode">
                  <el-select v-model="addForm.askAnswerNameCode" filterable style="width:100%" placeholder="请选择问卷调查">
                    <el-option
                        v-for="item in nameList"
                        :key="item.askAnswerNameCode"
                        :label="item.name"
                        :value="item.askAnswerNameCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="10" class="item">
                <el-form-item label="调查组名称" prop="groupName">
                  <el-input v-model="addForm.groupName" placeholder="请输入组名称"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="4" class="item">
                <el-form-item label="排序" prop="sort">
                  <el-input v-model.number="addForm.sort" placeholder="排序"></el-input>
                </el-form-item>
              </el-col>


            </el-row>

            <el-row>
              <el-col :span="24" class="item">

                <div>
                  <span>调查项</span>
                  <el-button style="float: right;" type="primary" @click="showModal">添加</el-button>
                  <div style="clear:both;"></div>
                </div>

                <div style="height: 10px;"></div>

                  <el-table :data="itemInfo" style="width: 100%;" border max-height="200">
                    <el-table-column prop="itemName" label="项名称"></el-table-column>
                    <el-table-column prop="itemSort" label="项排序"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="180">
                      <template slot-scope="scope">
                        <el-button type="primary" size="small" @click.native.prevent="deleteRow(scope.$index, itemInfo)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>

              </el-col>
            </el-row>

          </div>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">提交</el-button>
      </div>
    </div>

    <el-dialog title='添加项' :visible.sync="batchDialog" class="dialog" width='400px' center top='30vh' :close-on-click-modal='false' :modal-append-to-body='false'>
      <el-form>
        <el-form-item label="项名称" required style="width:100%">
          <el-input v-model="itemName" placeholder="请输入项名称"></el-input>
        </el-form-item>
        <el-form-item label="排序" required style="width:100%">
          <el-input v-model="itemSort" placeholder="请输入项排序"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog=false">取 消</el-button>
        <el-button type="primary" @click="addSub">提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Add",
  data() {
    return {

      loading: false,
      batchDialog: false,

      pageSize: 20,
      currentPage: 1,

      itemInfo: [],
      itemName: null,
      itemSort:0,

      nameList:[],


      addForm: {
        timeStr: timeStr,
        sign: '',
        staffCode: getStaffCode(),

        askAnswerNameCode:'',
        groupName: '',
        sort: 1,

        arr: [],

      },

      rules: {
        groupName: [
          {required: true, message: '请输入问卷调查组名称', trigger: 'blur'},
        ],
        askAnswerNameCode: [
          {required: true, message: '请选择问卷调查', trigger: 'blur'},
        ],
        sort: [
          {required: true, message: '请输入排序', trigger: 'blur'},
          {type: 'number', message: '排序必须为数字值'}
        ],
      }

    }
  },

  methods: {

    init() {
      this.itemInfo=[]
      this.$refs.addForm.resetFields();

      this.getList();
    },
    closeSelf() {
      this.$emit("closeAdd");
    },
    confirm(addForm) {
      this.$refs[addForm].validate((valid) => {
        if (valid) {
          this.addSubmit();
        } else {
          return false;
        }
      })

    },
    showModal(){
      this.itemName=null
      this.batchDialog=true
    },

    addSub(){
      if(!this.itemName){
        this.$message.error('请输入项名称')
        return
      }
      this.itemInfo.push({itemName:this.itemName,itemSort:this.itemSort})
      this.batchDialog=false
    },

    deleteRow(index, rows){
      rows.splice(index, 1);
    },

    addSubmit() {

      if(this.itemInfo.length==0){
        this.$message.error('请添加调查项')
        return
      }

      if (this.loading) {
        return;
      } else {
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey);
      this.addForm.arr=this.itemInfo
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "AskAnswerGroup/Add",
        data: this.addForm
      }).then((response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              this.$emit("getList");
            } else if (response.data.error == 1) {
              this.$message({type: 'info', message: response.data.message});
            }
          })
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'AskAnswerName/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.nameList = response.data.data.list;

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },



  }
}
</script>